import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import RouteManager from "./app/routes/RouteManager";
import AppWrapper from "./app/components/ui/AppWrapper/AppWrapper";
import ToastContainer from "./app/components/ui/ToastContainer/ToastContainer";
import BrandingProvider from "./app/context/BrandingProvider";

const queryClient = new QueryClient();

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("t");

    if (token) {
      sessionStorage.setItem("sessionToken", token);
      // params.delete("t");
      navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
    }
  }, [location.search, location.pathname, navigate]);

  return (
    <QueryClientProvider client={queryClient}>
      <BrandingProvider>
        <AppWrapper>
          <RouteManager />
          <ToastContainer />
        </AppWrapper>
      </BrandingProvider>
    </QueryClientProvider>
  );
}

export default App;
